import { selector } from '@poa/state';

export const filteredData = selector(store => {
  return store.accounts.data.map(table => {
    let tbody = table.tbody;

    return {
      thead: table.thead,
      tfoot: table.tfoot,
      title: table.title,
      tbody,
      _meta: table._meta
    };
  });
});

export const isAllColumnsSelected = selector(store => {
  return store.accounts.selectors.selectedPreset.columnsConfiguration.every(c => c.isSelected);
});
